import { render, staticRenderFns } from "./SellerDetail.vue?vue&type=template&id=3245476e&"
import script from "./SellerDetail.vue?vue&type=script&lang=js&"
export * from "./SellerDetail.vue?vue&type=script&lang=js&"
import style0 from "./SellerDetail.vue?vue&type=style&index=0&id=3245476e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports